import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

export const ChangeToAnotherChannelMessageSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      currentChannel: requiredString(t),
      channelId: requiredString(t),
    })
    .strict();

export type ChangeToAnotherChannelMessageType = z.infer<ReturnType<typeof ChangeToAnotherChannelMessageSchema>>;
